import { isInNextNDays, isInPast, isToday } from '@seen/core/dates'

import { cn, IconCalendar } from '@seen/ui'
import type { JSX } from 'react'

export function IconDue({
  dateString,
  isCompleted,
  className,
}: {
  dateString: string
  isCompleted: boolean
  className?: string
}): JSX.Element {
  if (isCompleted) {
    return <IconCalendar className={className} />
  }

  return isInPast(dateString) ? (
    <CalendarXIcon className={cn('text-red-500', className)} />
  ) : (
    <IconCalendar
      className={cn(
        isToday(dateString) && 'text-red-500',
        isInNextNDays(dateString, 7) && 'text-orange-500',
        !isToday(dateString) &&
          !isInNextNDays(dateString, 7) &&
          'text-foreground-secondary',
        className
      )}
    />
  )
}

function CalendarXIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={cn('shrink-0', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 1C13.2091 1 15 2.79086 15 5V6.25C15 6.66421 14.6642 7 14.25 7C13.8358 7 13.5 6.66421 13.5 6.25V6H2.5V11C2.5 12.3807 3.61929 13.5 5 13.5H6.25C6.66421 13.5 7 13.8358 7 14.25C7 14.6642 6.66421 15 6.25 15H5C2.79086 15 1 13.2091 1 11V5C1 2.79086 2.79086 1 5 1H11ZM9.53033 8.46967L11.5 10.4393L13.4697 8.46967C13.7626 8.17678 14.2374 8.17678 14.5303 8.46967C14.8232 8.76256 14.8232 9.23744 14.5303 9.53033L12.5607 11.5L14.5303 13.4697C14.8232 13.7626 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L11.5 12.5607L9.53033 14.5303C9.23744 14.8232 8.76256 14.8232 8.46967 14.5303C8.17678 14.2374 8.17678 13.7626 8.46967 13.4697L10.4393 11.5L8.46967 9.53033C8.17678 9.23744 8.17678 8.76256 8.46967 8.46967C8.76256 8.17678 9.23744 8.17678 9.53033 8.46967Z"></path>
    </svg>
  )
}
